export default __webpack_public_path__ + "static/media/q9_step1_1.36ef0c70.png";